import React, { useRef } from 'react'
import classnames from 'classnames/bind'

import { ReactComponent as Search } from './search.svg'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const InputText = ({ icon, onChange, className, ...rest }) => {
  const input = useRef()

  const _onChange = () => onChange(input.current && input.current.value)

  return (
    <div className={cx(css.InputText, className, { withIcon: icon })}>
      <input
        ref={input}
        onChange={onChange && _onChange}
        type="text"
        {...rest}
      />
      {icon && <Search className={css.icon} />}
    </div>
  )
}

export default InputText
